export default __webpack_public_path__ + "static/media/Video-thumbnail.6d590a02.jpeg";